exports.onClientEntry = () => {
    const scripts = Array.from(document.getElementsByTagName("head")[0].children);
    scripts.forEach((item) => {
        if ((item.tagName === "SCRIPT" && item.src.includes("analytics")) || (item.tagName === "SCRIPT" && item.innerText.includes("analytics"))) {
            item.type = "text/plain";
            item.setAttribute("data-cookiecategory", "analytics");
        }
    });
};
